import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../Assets/Logos/w-logo.png";
import icon from "../../Assets/Home/FooterIcon.png";

// Social icons
const SocialIcon = ({ children }) => (
  <a
    href="#"
    className="w-8 h-8 rounded flex items-center justify-center border border-gray-600 text-gray-400 hover:border-[#e8341c] hover:text-[#e8341c] transition-colors duration-200"
  >
    {children}
  </a>
);

const UserFooter = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState("");
  const [agreed, setAgreed] = useState(false);

  const quickLinks = [
    {
      lable: "Home",
      slug: "/",
    },
    {
      lable: "About Us",
      slug: "/about",
    },
    {
      lable: "Portfolio",
      slug: "/portfolio",
    },
    {
      lable: "Contact",
      slug: "/contact",
    },
  ];

  const services = [
    {
      lable: "Mining Services",
      slug: "mining-services",
    },
    {
      lable: "Fabrication Services",
      slug: "fabrication-services",
    },
    {
      lable: "Construction Services",
      slug: "construction-services",
    },
    {
      lable: "Crusher Operation",
      slug: "crusher-operation",
    },
    {
      lable: "Logistics",
      slug: "logistics",
    },
  ];
  return (
    <React.Fragment>
      {/* Main footer */}
      <footer className="relative overflow-hidden bg-black *: px-4 sm:px-8 pt-14 pb-10">
        <div className="relative z-10 max-w-7xl mx-auto ">
          {/* Top section — tagline + logo */}
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-6">
            <div>
              <p
                className="text-gray-400 text-xs font-bold tracking-[0.22em] uppercase mb-4 pb-1"
                style={{
                  borderBottom: "1px solid #e8341c",
                  display: "inline-block",
                }}
              >
                FROM QUARRY TO QUALITY
              </p>
              <h2
                className="text-white font-black leading-none uppercase font-krona text-2xl md:text-4xl lg:text-[40px] "
                style={{
                  letterSpacing: "0.04em",
                  lineHeight: 1.1,
                }}
              >
                YOUR TRUSTED PARTNER
                <br />
                IN MEGA PROJECTS
              </h2>
            </div>
            <div className="md:text-right flex-shrink-0">
              <img
                src={logo}
                alt="Logo"
                className="w-full h-20 object-contain"
              />
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-700 mb-10" />

          {/* 4-column content */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Col 1 — About + Social */}
            <div>
              <p className="text-gray-400 text-sm leading-relaxed mb-6">
                A comprehensive mining services platform designed to showcase
                industrial solutions, equipment, and project capabilities,
                helping businesses connect with reliable mining operations and
                services.
              </p>
              <p className="text-white font-bold text-sm mb-3">Social Info</p>
              <div className="flex gap-2">
                {/* Facebook */}
                <SocialIcon>
                  <svg
                    className="w-3.5 h-3.5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                  </svg>
                </SocialIcon>
                {/* Twitter */}
                <SocialIcon>
                  <svg
                    className="w-3.5 h-3.5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                  </svg>
                </SocialIcon>
                {/* LinkedIn */}
                <SocialIcon>
                  <svg
                    className="w-3.5 h-3.5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                    <circle cx="4" cy="4" r="2" />
                  </svg>
                </SocialIcon>
                {/* Pinterest/Other */}
                <SocialIcon>
                  <svg
                    className="w-3.5 h-3.5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <circle cx="12" cy="12" r="3" />
                    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
                  </svg>
                </SocialIcon>
              </div>
            </div>

            {/* Col 2 — Quick Links */}
            <div>
              <h4 className="text-white font-bold text-base mb-5">
                Quick links
              </h4>
              <ul className="space-y-2.5">
                {quickLinks.map((link) => (
                  <li key={link}>
                    <button
                      onClick={() => {
                        navigate(`${link.slug}`);
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                      className="text-gray-400 text-sm hover:text-[#e8341c] transition-colors duration-200"
                    >
                      {link.lable}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Col 3 — Our Services */}
            <div>
              <h4 className="text-white font-bold text-base mb-5">
                Our Services
              </h4>
              <ul className="space-y-2.5">
                {services.map((s) => (
                  <li key={s}>
                    <button
                      onClick={() => {
                        navigate(`/services/${s.slug}`);
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                      className="text-gray-400 text-sm hover:text-[#e8341c] transition-colors duration-200"
                    >
                      {s.lable}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Col 4 — Newsletter */}
            <div>
              <h4 className="text-white font-bold text-base mb-5">
                Our Newsletter
              </h4>

              {/* Email input + send button */}
              <div className="flex mb-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  className="flex-1 bg-gray-800 text-gray-300 text-sm px-4 py-2.5 rounded-l outline-none placeholder-gray-500 border border-gray-700 focus:border-[#e8341c] transition-colors"
                />
                <button className="bg-[#e8341c] hover:bg-[#c42b14] text-white px-4 py-2.5 rounded-r transition-colors duration-200 flex items-center justify-center">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2.5}
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </div>

              {/* Checkbox */}
              <label className="flex items-start gap-2 cursor-pointer mb-6">
                <input
                  type="checkbox"
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                  className="mt-0.5 accent-[#e8341c] flex-shrink-0"
                />
                <span className="text-gray-500 text-xs leading-relaxed">
                  I agree that submitted data is being collected and stored..
                </span>
              </label>

              {/* Contact info */}
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-0.5">
                  <img src={icon} alt="" className="size-10 object-contain" />
                </div>
                <div>
                  <p className="text-white font-bold text-sm">
                    +91 977 777 4005
                  </p>
                  <p className="text-[#e8341c] text-xs mt-0.5 hover:underline cursor-pointer">
                    headoffice@prudenceindia.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Bottom bar */}
      <div
        className="flex flex-wrap items-center justify-between px-8 py-4 text-xs text-gray-400 gap-2"
        style={{ background: "#0a0a0a", fontFamily: "'Barlow', sans-serif" }}
      >
        <div className="flex items-center gap-2 flex-wrap">
          <a href="#" className="hover:text-white transition-colors">
            Help
          </a>
          <span className="text-gray-600">/</span>
          <a href="#" className="hover:text-white transition-colors">
            Terms & Conditions
          </a>
          <span className="text-gray-600">/</span>
          <a href="#" className="hover:text-white transition-colors">
            Privacy Policy
          </a>
          <span className="text-gray-600">/</span>
          <a href="#" className="hover:text-white transition-colors">
            Procurement
          </a>
        </div>
        <div className="flex items-center gap-1">
          <span>Copyright © {currentYear} PRUDENCE. Designed By</span>
          <span
            onClick={() => window.open("https://webbocket.com/", "_blank")}
            className="text-white font-semibold cursor-pointer hover:text-[#e8341c] transition-colors ml-1"
          >
            Webbocket
          </span>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserFooter;
